import { render, staticRenderFns } from "./VehicleName.vue?vue&type=template&id=486de5ff"
import script from "./VehicleName.vue?vue&type=script&lang=js"
export * from "./VehicleName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports